import React, { useContext, useRef } from 'react';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import PbxContext from '../../context/PbxContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

const ChartCallsStatusByDay = ({ getRows }) => {
  const getItensStateGlobal = useContext(PbxContext);
  const { storageDataReport, dataForRequestCalls } = getItensStateGlobal;

  const receivedsDays = storageDataReport.receivedsDays || {};
  const labels = Object.keys(receivedsDays);

  const chartCallsDaysReceivedsRef = useRef(null);

  const getDataToRequestFilter = (event) => {
    const { dateStart, dateStop } = dataForRequestCalls;
    const date1 = new Date(dateStart); 
    const date2 = new Date(dateStop); 

    const year1 = date1.getFullYear();
    const mounth1 = date1.getUTCMonth();
    
    const year2 = date2.getFullYear();
    const mounth2 = date2.getUTCMonth();

    if (year1 !== year2) return;
    if (mounth1 !== mounth2) return;

    if (chartCallsDaysReceivedsRef.current) {
    const chart = ChartJS.getChart(chartCallsDaysReceivedsRef.current);
    const clickedElements = chart.getElementsAtEventForMode(event, 'nearest',{ intersect: true }, true);
    if (clickedElements.length > 0) {
      const firstElement = clickedElements[0];
      let labelType = chart.data.datasets[firstElement.datasetIndex].label;
      const labelIndexClicked = chart.data.labels[firstElement.index];

      labelType === 'Não Atendidas' ? labelType = 'perdida' : labelType = 'atendida';

      getRows('receiveds-days', labelIndexClicked, labelType);
    }
   }
  };

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        // text: 'Chart.js Bar Chart',
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: 'Atendidas',
        data: labels.map((label) => (receivedsDays[label] && receivedsDays[label].atendidas) ?? 0),
        fill: true,
        backgroundColor: "rgba(53, 162, 235,0.8)",
        borderColor: "rgba(30, 144, 255, 0.8)"
      },
      {
        label: 'Não Atendidas',
        data: labels.map((label) => (receivedsDays[label] && receivedsDays[label].perdidas) ?? 0),
        fill: true,
        backgroundColor: "rgba(255, 99, 132, 0.7)",
        borderColor: "rgba(255, 99, 132, 0.8)",
      },
    ]
  };

  // const exportExcelDownload = () => {
  //   const arrayAtendidas = valueLabelsAtendidas[0];
  //   const arrayNaoAtendidas = valueLabelsNaoAtendidas[0];

  //   const data = labels.map((hour) => {
  //     const atendidas = arrayAtendidas[hour] ? arrayAtendidas[hour] : '0';
  //     const naoAtendidas = arrayNaoAtendidas[hour] ? arrayNaoAtendidas[hour] : '0';
  //     const objElements = { hour, atendidas, naoAtendidas };
  //     return objElements;
  //   });
  //   return { name: 'Chamadas_Hora', description: 'Chamadas Por Hora', data }
  // };
  // exportExcelDownload();

  return (
    <div className='column is-half' >
      <h2 className="has-text-centered is-size-5">Status das Chamadas Recebidas por Dia</h2>
        <Bar options={options} data={data} plugins={[ChartDataLabels]} ref={chartCallsDaysReceivedsRef} getElementAtEvent={(_, event) => getDataToRequestFilter(event)} />
    </div>
  );
}

export default ChartCallsStatusByDay;
